var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-content"},[_c('img',{staticClass:"float-right m-2 logo-s",attrs:{"alt":"small logo","width":"100","src":require("../../assets/auth/cpdme-small-logo.png")}}),_c('div',{staticClass:"tab-content p-5"},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }